import moment from 'moment';

import { firstOf, lastOf } from 'utils/arrays/elements.util';
import { timeAdd15min, timeAdd30min, timeAdd45min, timeAdd60min, timeSub15min, timeSub30min, timeSub45min, timeSub60min } from 'utils/date/manipulate.util';
import logger from 'utils/logger.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';

const L = logger('fromHoursRangeToExpanded'); // eslint-disable-line no-unused-vars

const fromIsoToMoment = (iso) => moment(iso);

const fromHoursRangeToExpanded = (range) => {
  const items = isFullArray(range) ? range : [];

  if (!items.length) return items;

  try {
    const bgn = firstOf(items);
    const end = lastOf(items);

    const prefix = [timeSub60min(bgn), timeSub45min(bgn), timeSub30min(bgn), timeSub15min(bgn)];
    const suffix = [timeAdd15min(end), timeAdd30min(end), timeAdd45min(end), timeAdd60min(end)];

    // NOTE: the time instances are all Moment objects, so make sure you keep the same object type with the expanded
    return [...prefix.map(fromIsoToMoment), ...items, ...suffix.map(fromIsoToMoment)];
  } catch (e) {
    L.warn('fromHoursRangeToExpanded()', e);
    return items;
  }
};

export default fromHoursRangeToExpanded;
